exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".starWrap {\n  display: inline-block;\n}\n.starWrap .el-rate {\n  white-space: nowrap;\n}\n.starWrap .el-rate .el-rate__item {\n  padding-left: 0 !important;\n  margin-right: -2px !important;\n}\n.starWrap .el-rate .el-rate__item .el-rate__icon {\n  font-size: 22px;\n  margin-right: 0 !important;\n}", ""]);

// exports
